import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_AGMSupport/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // ----------------------------------------- Support --------------------------------------------------------

  const ReadyMadeMasterPage = lazy(
    () => import('../modules/support-page/ready-made-master-pages/ReadyMadeMasterPage')
  )

  const DiyMasterPage = lazy(() => import('../modules/support-page/diy-master-pages/DiyMasterPage'))
  const ModularMasterPage = lazy(
    () => import('../modules/support-page/modular-master-pages/ModularMasterPage')
  )

  // ================================= Change Password ==========================
  // const ChangePasswordPage = lazy(() => import('../modules/change-password/ChangePasswordPage'))

  {
    /* --------------------------- Organization ------------------------- */
  }

  // const EmployeeMasterPage = lazy(
  //   () => import('../modules/organization-page/employee-master-page/EmployeeMasterPage')
  // )

  // const UserMasterPage = lazy(
  //   () => import('../modules/organization-page/user-master-page/UserMasterPage')
  // )

  // ================================= Masters ==========================

  // const DistrictMasterPage = lazy(
  //   () => import('../modules/master-page/district-master-page/DistrictMasterPage')
  // )
  // const CountryMasterPage = lazy(
  //   () => import('../modules/master-page/country-master-page/CountryMasterPage')
  // )
  // const StateMasterPage = lazy(
  //   () => import('../modules/master-page/state-master-page/StateMasterPage')
  // )
  // const TalukaMasterPage = lazy(
  //   () => import('../modules/master-page/taluka-master-page/TalukaMasterPage')
  // )
  // const NationalityMasterPage = lazy(
  //   () => import('../modules/master-page/nationality-master-page/NationalityMasterPage')
  // )
  // const EducationCategoryPage = lazy(
  //   () => import('../modules/master-page/education-category-master-page/EducationCategoryPage')
  // )
  // const EducationDepartmentPage = lazy(
  //   () => import('../modules/master-page/education-department-master-page/EducationDepartmentPage')
  // )
  // const DocumentTypePage = lazy(
  //   () => import('../modules/master-page/document-type-page/DocumentTypePage')
  // )
  // const DepartmentMasterPage = lazy(
  //   () => import('../modules/master-page/department-master-page/DepartmentMasterPage')
  // )
  // const DesignationMasterPage = lazy(
  //   () => import('../modules/master-page/designation-master-page/DesignationMasterPage')
  // )
  // const BranchMasterPage = lazy(
  //   () => import('../modules/master-page/branch-master-page/BranchMasterPage')
  // )
  // const BHKMasterPage = lazy(() => import('../modules/master-page/bhk-master-page/BHKMasterPage'))
  // const CarpetAreaMasterPage = lazy(
  //   () => import('../modules/master-page/carpet-area-page/CarpetAreaMasterPage')
  // )

  // const DNCTypeMasterPage = lazy(
  //   () => import('../modules/master-page/dnc-type-master-page/DNCTypeMasterPage')
  // )
  // const LeadStatusMasterPage = lazy(
  //   () => import('../modules/master-page/lead-status-page/LeadStatusMasterPage')
  // )
  // const LeadTypeMasterPage = lazy(
  //   () => import('../modules/master-page/lead-type-page/LeadTypeMasterPage')
  // )
  // const PipeLineMasterPage = lazy(
  //   () => import('../modules/master-page/pipeline-master-page/PipeLineMasterPage')
  // )

  // const ReasonTypeMasterPage = lazy(
  //   () => import('../modules/master-page/reason-type-page/ReasonTypeMasterPage')
  // )

  // ========================================================================

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        {/* --------------------------- Support ------------------------- */}
        <Route path='/support/diy' component={DiyMasterPage} />
        <Route path='/support/readymade' component={ReadyMadeMasterPage} />
        <Route path='/support/modular' component={ModularMasterPage} />
        {/* --------------------------- Organization -------------------------
        <Route path='/organization/employee' component={EmployeeMasterPage} />
        <Route path='/organization/user' component={UserMasterPage} /> */}
        {/* --------------------------- Masters -------------------------
        <Route path='/master/district' component={DistrictMasterPage} />
        <Route path='/master/state' component={StateMasterPage} />
        <Route path='/master/country' component={CountryMasterPage} />
        <Route path='/master/taluka' component={TalukaMasterPage} />
        <Route path='/master/nationality' component={NationalityMasterPage} />
        <Route path='/master/eduDepartment' component={EducationDepartmentPage} />
        <Route path='/master/eduCategory' component={EducationCategoryPage} />
        <Route path='/master/documenttype' component={DocumentTypePage} />
        <Route path='/master/department' component={DepartmentMasterPage} />
        <Route path='/master/designation' component={DesignationMasterPage} />
        <Route path='/master/branch' component={BranchMasterPage} />
        <Route path='/master/bhkMaster' component={BHKMasterPage} />
        <Route path='/master/carpetArea' component={CarpetAreaMasterPage} />
        <Route path='/master/dnc-type' component={DNCTypeMasterPage} />
        <Route path='/master/pipelines' component={PipeLineMasterPage} />
        <Route path='/master/reason-type' component={ReasonTypeMasterPage} />
        <Route path='/master/lead-status' component={LeadStatusMasterPage} />
        <Route path='/master/lead-type' component={LeadTypeMasterPage} /> */}
        {/* --------------------------- Projects ------------------------- */}

        <Redirect from='/' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
